const sourceLabels = {
  ASSOCIATE: 'App',
  CLIENT: 'Kiosk',
};

export default function getAppointmentSourceLabel(source) {
  return sourceLabels[source] || '';
}
